import axiosInstance from "./AxiosInstance";

export const getStudentDashboard = async (params = {}) => {
  try {
    // Use legacy endpoint for admin features or specific student viewing, 
    // New endpoint for students viewing their own dashboard
    const response = await axiosInstance.get("/studentdashboard", { params, timeout: 60000 });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data; // Server returns graceful fallback data with 404 status
    }
    throw error;
  }
};

/* The student page, one section per request. StudentDashboard2 fires the
   four together and draws each section as its own answer lands, rather
   than waiting for the whole /studentdashboard payload. Each takes the
   same { studentId } / { email } a staff viewer passes; a student passes
   nothing and gets their own. Each resolves to the response body. */
const section = (path) => async (params = {}) => {
  const response = await axiosInstance.get(`/studentdashboard/${path}`, { params, timeout: 60000 });
  return response.data;
};
// student, batches, upcoming/active/feed, nextUp and the counts
export const getStudentDashboardBatches = section("batches");
// attendancePercentage, classesAttended, attendanceBand / Tone
export const getStudentDashboardAttendance = section("attendance");
// enrolledCourses, totalCourseEnrolled
export const getStudentDashboardCourses = section("courses");
// suggestedBatches
export const getStudentDashboardSuggested = section("suggested");

// The dashboard's batch feed, searched and ordered by the API.
// params: { search, order: 'newest' | 'oldest' } (+ studentId / email for staff).
export const getStudentDashboardFeed = async (params = {}) => {
  const response = await axiosInstance.get("/studentdashboard/feed", { params, timeout: 60000 });
  return response.data;
};

/**
 * "My Attendance Report": the signed-in student's own attendance, every
 * figure worked out by the API. Params: dateFrom, dateTo, batchId, courseId,
 * trainerId, status ('present' | 'absent', the list only), granularity,
 * page, limit. Resolves to { summary, trend, items, options, granularity }
 * and `pagination`.
 */
export const getAttendanceReport = async (params = {}) => {
  const response = await axiosInstance.get("/studentdashboard/attendance-report", { params });
  return {
    ...(response.data?.data || {}),
    pagination: response.data?.pagination || null,
  };
};

/**
 * One class of that report, in full, for its view popup: topics, batch,
 * course, trainer, timings and the student's own feedback -- nothing about
 * other students. The student's own classes only (404 otherwise).
 */
export const getAttendanceReportSession = async (id) => {
  const response = await axiosInstance.get(`/studentdashboard/attendance-report/${id}`);
  return response.data?.data || null;
};

export const getAttendanceRecords = async (params = {}) => {
  try {
    const response = await axiosInstance.get("/studentdashboard/attendance-records", { params });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    throw error;
  }
};
